import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import LogEvent from 'automation-ui-log-events/records/LogEvent/LogEvent';
import { LogEventTypes } from 'automation-ui-log-events/constants/LogEventConstants';
export const FETCH_LOG_EVENTS_FIELDNAME = 'logEvents';
export const FETCH_LOG_EVENTS = registerQuery({
  fieldName: FETCH_LOG_EVENTS_FIELDNAME,
  args: ['actionExecutionId', 'actionSpecificErrorType', 'actionType', 'actionTypeIds', 'endTimestamp', 'errorType', 'eventTypes', 'flowId', 'isHybrid', 'limit', 'notificationType', 'objectId', 'objectTypeId', 'offset', 'startTimestamp'],
  fetcher({
    actionExecutionId,
    actionSpecificErrorType,
    actionType,
    actionTypeIds,
    endTimestamp,
    errorType,
    eventTypes,
    flowId,
    isHybrid = false,
    limit = 50,
    notificationType,
    objectId,
    objectTypeId,
    offset,
    startTimestamp
  }) {
    return http.post('automationapps/v1/history', {
      data: {
        actionExecutionId,
        actionSpecificErrorType,
        actionType,
        actionTypeIds,
        endTimestamp,
        errorType,
        eventTypes,
        flowId,
        isHybrid,
        limit,
        notificationType,
        objectId,
        objectTypeId,
        offset,
        startTimestamp
      }
    }).then(response => {
      if (response.results) {
        response.results = response.results.map(logEvent => {
          return new LogEvent(logEvent);
        });
      }
      return response;
    });
  }
});
export const FETCH_LOG_EVENTS_FIELD_POLICY = {
  keyArgs: ['actionExecutionId', 'actionSpecificErrorType', 'actionType', 'actionTypeIds', 'endTimestamp', 'errorType', 'eventTypes', 'flowId', 'isHybrid', 'notificationType', 'objectId', 'objectTypeId', 'startTimestamp'],
  merge(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    return Object.assign({}, incoming, {
      results: [...existing.results, ...incoming.results]
    });
  }
};
export const LATEST_ENROLLMENT_LOG_EVENT_FIELDNAME = 'latestEnrollmentLogEvent';
export const FETCH_LATEST_ENROLLMENT_LOG_EVENT = registerQuery({
  fieldName: LATEST_ENROLLMENT_LOG_EVENT_FIELDNAME,
  args: ['flowId', 'isHybrid'],
  fetcher({
    flowId,
    isHybrid,
    eventTypes
  }) {
    return http.post('automationapps/v1/history', {
      data: {
        limit: 1,
        flowId,
        isHybrid,
        eventTypes
      }
    }).then(response => new LogEvent(response.results[0]));
  }
});
export const LOG_EVENT_BY_IDEMPOTENCY_ID_FIELDNAME = 'logEventByIdempotencyId';
export const FETCH_LOG_EVENT_BY_IDEMPOTENCY_ID = registerQuery({
  fieldName: LOG_EVENT_BY_IDEMPOTENCY_ID_FIELDNAME,
  args: ['flowId', 'idempotencyId', 'isHybrid'],
  fetcher({
    flowId,
    idempotencyId,
    isHybrid
  }) {
    return http.post('automationapps/v1/history', {
      data: {
        flowId,
        idempotencyId,
        isHybrid
      }
    }).then(({
      results
    }) => results && results.length ? new LogEvent(results[0]) : null);
  }
});
export const LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME = 'logEventsForHistoryEnrollment';
export const FETCH_LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE = registerQuery({
  fieldName: LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME,
  args: ['flowId', 'enrollmentId', 'isHybrid'],
  fetcher({
    flowId,
    enrollmentId,
    isHybrid
  }) {
    return http.post('automationapps/v1/history', {
      data: {
        flowId,
        isHybrid,
        enrollmentId,
        eventTypes: [LogEventTypes.ENROLLMENT, LogEventTypes.UNENROLLMENT, LogEventTypes.ACTION_EXECUTION]
      }
    }).then(({
      results
    }) => results ? results.map(logEvent => new LogEvent(logEvent)) : []);
  }
});